import { render, staticRenderFns } from "./case-approval-common.vue?vue&type=template&id=5cd9d28a"
import script from "./case-approval-common.vue?vue&type=script&lang=ts"
export * from "./case-approval-common.vue?vue&type=script&lang=ts"
import style0 from "./case-approval-common.vue?vue&type=style&index=0&id=5cd9d28a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports